import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import ConsultationModal from '../components/ConsultationModal';
import Hero from '../components/home/Hero';
import Stats from '../components/home/Stats';
import Products from '../components/home/Products';
import Partners from '../components/home/Partners';
import Testimonials from '../components/home/Testimonials';
import Footer from '../components/Footer';
import WhyUs from '../components/home/WhyUs';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar setIsModalOpen={setIsModalOpen} />
      <main>
        <Hero setIsModalOpen={setIsModalOpen} />
        <Stats />
        <Products setIsModalOpen={setIsModalOpen} />
        <WhyUs />
        <Partners />
        <Testimonials />
      </main>
      <ConsultationModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
      <Footer />
    </div>
  );
};

export default Home; 